import { request, ServiceResult } from "@insite/client-framework/Services/ApiService";

export async function validateMilitaryMember(parameter: string): Promise<ServiceResult<string | null>> {
    const aihAddAccountURL = "/api/v1/AlaskaAccount/ValidateMilitaryMember";
    try {
        console.log("calling api: /api/v1/AlaskaAccount/ValidateMilitaryMember.. \n Response: ");
        const data = await request<string | null>(`${aihAddAccountURL}?code=${parameter}`, "GET");
        console.log(data);
        return {
            successful: true,
            result: data,
        };
    } catch (error) {
        if ("status" in error && (error.status === 400 || error.status === 403 || error.status === 404)) {
            return {
                successful: false,
                errorMessage: error?.errorJson?.message || error?.errorMessage || "error",
                statusCode: error.status,
            };
        }
        throw error;
    }
}
